module.exports = __webpack_public_path__ + "media/images/default_avatar-581abac0cda2c9d8e2832b0c0cb10fa2.png";